import isEmpty from "is-empty";
import { Auth } from "../services/Auth";

export const verifyTermsMiddleware = (to, from, next) => {

    const user = Auth.user()

    if(isEmpty(user.object)) {
        return next();
    }

    if(to.name == 'terms-and-conditions') {
        return next();
    }

    if (!user.hasTermsAccepted()) {
        return next({ name: 'terms-and-conditions' });
    }

    return next();
}